module.exports = __webpack_public_path__ + "static/media/ubuntu.d4b9fc84.png";